/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespIconBubblesWrapper_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"PdpRespIconBubbles_viewer" | "PdpRespTradeIconBubbles_viewer">;
    readonly " $refType": "PdpRespIconBubblesWrapper_viewer";
};
export type PdpRespIconBubblesWrapper_viewer$data = PdpRespIconBubblesWrapper_viewer;
export type PdpRespIconBubblesWrapper_viewer$key = {
    readonly " $data"?: PdpRespIconBubblesWrapper_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespIconBubblesWrapper_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespIconBubblesWrapper_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespIconBubbles_viewer",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isTrade",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "PdpRespTradeIconBubbles_viewer",
          "args": null
        }
      ]
    }
  ]
};
(node as any).hash = '50d384ae4d7efb2d8117904c0184cfaf';
export default node;
